// 导入 抽取的 请求对象
import ajaxRequest from '../utils/request';

const reFix = 'useradmin';

// 获取列表
export function getpmcStatisticstListApi(params) {
  return ajaxRequest({
    url: reFix + '/PmcStatisticst/pmcStatisticstList',
    method: 'GET',
    params: { ...params },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
